import * as React from "react";
import { IconProps } from "../types";

const GridLayoutCols3Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g transform="translate(1.75 2.234) scale(1.242857)">
          <path
            d="M4.08333 0.58355V10.3058"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M7.58333 0.58355V10.3058"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
          <path
            d="M10.3056 0.583333H1.36111C0.93156 0.583333 0.583333 0.93156 0.583333 1.36111V9.52778C0.583333 9.95734 0.93156 10.3056 1.36111 10.3056H10.3056C10.7351 10.3056 11.0833 9.95734 11.0833 9.52778V1.36111C11.0833 0.93156 10.7351 0.583333 10.3056 0.583333Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
        </g>
      </svg>
    );
  },
);

export default GridLayoutCols3Icon;
